import routes from '@routes/config';

export default [{
    path: routes.billRow.index,
    name: routes.billRow.index,
    component: () => import(/* webpackChunkName: "BillRow" */  '@components/BillRow/Index')
}]
            